import cn from "classnames"
import { DynamicHeadline } from "../DynamicHeadline"
import Section from "../Section"
import styles from "./TeaserLinks.module.scss"
import TeaserLinksFancyGridItem from "./TeaserLinksFancyGridItem"
import TeaserLinksGridItem from "./TeaserLinksGridItem"
import TeaserLinksItem from "./TeaserLinksItem"

const GridFillerElement = () => {
  return (
    <div className={styles.gridFillerElementWrapper}>
      <div className={styles.gridFillerElement}>
        <div className={styles.gridFillerElementTop}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 588 228"
            preserveAspectRatio="none"
          >
            <path
              fill="currentColor"
              d="M388 228c110.457 0 200-89.543 200-200V0H0v228h388Z"
            />
          </svg>
        </div>
        <div className={styles.gridFillerElementBottom}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 228 228"
          >
            <path
              fill="currentColor"
              d="M228 228H0V0h28c110.457 0 200 89.543 200 200v28Z"
            />
          </svg>
          <div className={styles.gridFillerElementBottomRectangle}></div>
        </div>
      </div>
    </div>
  )
}

const TeaserLinks = ({ data, colors, content }) => {
  // console.log("TeaserLinks", data)
  const {
    dynamic_headline: headline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    teasers,
    display_type,
    ankerslug,
    image_background_color,
  } = data

  const imageBackgroundColor = image_background_color || "#40454A"

  const displayType = display_type?.value || "list"

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      id={ankerslug}
      className={cn({
        [styles.list]: displayType === "list",
        [styles.displayGrid]: displayType === "grid",
        [styles.fancyGrid]: displayType === "fancy-grid",
      })}
      colors={colors}
    >
      {headline && (
        <DynamicHeadline
          className={styles.teaserHeadline}
          headlineType={headlineType.value}
          headlineAppearance={headlineAppearance.value}
        >
          {headline}
        </DynamicHeadline>
      )}
      <div className={styles.teaserWrapper}>
        {teasers &&
          teasers.map((teaser, index) =>
            displayType === "list" ? (
              <TeaserLinksItem teaser={teaser} key={index} />
            ) : displayType === "grid" ? (
              <TeaserLinksGridItem
                teaser={teaser}
                key={index}
                className={styles.gridItem}
              />
            ) : displayType === "fancy-grid" ? (
              <TeaserLinksFancyGridItem
                teaser={teaser}
                itemBgColor={imageBackgroundColor}
                key={index}
                className={styles.fancyGridItem}
                content={content}
              />
            ) : null
          )}
        {displayType === "grid" && teasers % 2 !== 0 && <GridFillerElement />}
      </div>
    </Section>
  )
}

export default TeaserLinks
